<div class="modal-header sim-header">
  <div class="min-w-0">
    <h5 class="modal-title d-flex align-items-center gap-2">
      <span class="sim-title-icon"><i class="ri-calculator-line"></i></span>
      {{ "t-simulators.t-title" | translate }}
    </h5>
    <p class="text-muted fs-12 mb-0">{{ "t-simulators.t-subtitle" | translate }}</p>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body sim-body">
  <!-- Separadores + ligação entre os dois -->
  <div class="sim-toolbar">
    <div class="sim-tabs" role="tablist">
      <button type="button" role="tab" [class.is-active]="tab === 'imt'" (click)="setTab('imt')">
        <i class="ri-government-line"></i>
        <span>{{ "t-simulators.t-tab-imt" | translate }}</span>
        <small *ngIf="imtEstimate">{{ money(imtEstimate.total) }}</small>
      </button>
      <button type="button" role="tab" [class.is-active]="tab === 'credit'" (click)="setTab('credit')">
        <i class="ri-bank-line"></i>
        <span>{{ "t-simulators.t-tab-credit" | translate }}</span>
        <small *ngIf="monthlyPayment !== null">{{ money(monthlyPayment) }}/{{ "t-simulators.t-month" | translate }}</small>
      </button>
    </div>

    <label
      class="sim-link"
      [class.is-on]="linked"
      [ngbTooltip]="'t-simulators.t-link-hint' | translate"
      placement="bottom"
      container="body"
    >
      <input class="form-check-input" type="checkbox" role="switch" [checked]="linked" (change)="toggleLinked()" />
      <i class="ri-link"></i>
      <span>{{ "t-simulators.t-link" | translate }}</span>
    </label>
  </div>

  <!-- ================================================================ IMT -->
  <div class="row g-4" *ngIf="tab === 'imt'">
    <div class="col-12 col-lg-5">
      <form [formGroup]="imtForm" class="sim-form">
        <div class="mb-3">
          <label class="form-label">{{ "t-simulators.t-price" | translate }}</label>
          <div class="input-group input-group-lg sim-input-hero">
            <input
              type="text"
              class="form-control"
              formControlName="price"
              mask="separator"
              thousandSeparator=" "
              inputmode="numeric"
              placeholder="250 000"
              autofocus
            />
            <span class="input-group-text">€</span>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label">{{ "t-simulators.t-purpose" | translate }}</label>
          <ng-select formControlName="purpose" [clearable]="false" [searchable]="false" appendTo="body">
            <ng-option *ngFor="let purpose of purposes" [value]="purpose">
              {{ "t-simulators.t-purpose-" + purpose | translate }}
            </ng-option>
          </ng-select>
        </div>

        <div class="row g-3 mb-3">
          <div class="col-12 col-sm-7">
            <label class="form-label">{{ "t-simulators.t-region" | translate }}</label>
            <ng-select formControlName="region" [clearable]="false" [searchable]="false" appendTo="body">
              <ng-option *ngFor="let region of regions" [value]="region">
                {{ "t-simulators.t-region-" + region | translate }}
              </ng-option>
            </ng-select>
          </div>
          <div class="col-12 col-sm-5">
            <label class="form-label">{{ "t-simulators.t-vpt" | translate }}</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                formControlName="taxableAssetValue"
                mask="separator"
                thousandSeparator=" "
                inputmode="numeric"
              />
              <span class="input-group-text">€</span>
            </div>
          </div>
        </div>
        <p class="text-muted fs-11 mb-3">{{ "t-simulators.t-vpt-hint" | translate }}</p>

        <label class="sim-check" [class.is-disabled]="!isOwnPermanent">
          <input class="form-check-input" type="checkbox" formControlName="youngBuyer" [attr.disabled]="isOwnPermanent ? null : true" />
          <span>
            {{ "t-simulators.t-young-buyer" | translate }}
            <small class="d-block text-muted">{{ "t-simulators.t-young-buyer-hint" | translate }}</small>
          </span>
        </label>
      </form>
    </div>

    <div class="col-12 col-lg-7">
      <!-- Sem preço ainda -->
      <div class="sim-empty" *ngIf="!(imtPrice > 0)">
        <i class="ri-government-line"></i>
        <p>{{ "t-simulators.t-imt-empty" | translate }}</p>
      </div>

      <ng-container *ngIf="imtPrice > 0">
        <div class="sim-hero" [class.is-loading]="imtLoading">
          <div>
            <p class="sim-hero-label">{{ "t-simulators.t-taxes-total" | translate }}</p>
            <p class="sim-hero-value">
              <span class="spinner-border spinner-border-sm" *ngIf="imtLoading && !imtEstimate"></span>
              <ng-container *ngIf="imtEstimate">{{ money(imtEstimate.total) }}</ng-container>
            </p>
            <p class="sim-hero-sub" *ngIf="imtEffectiveRate !== null">
              {{ "t-simulators.t-effective-rate" | translate: { rate: imtEffectiveRate } }}
            </p>
          </div>
          <div class="sim-hero-side" *ngIf="acquisitionTotal !== null">
            <p class="sim-hero-label">{{ "t-simulators.t-acquisition-total" | translate }}</p>
            <p class="sim-hero-side-value">{{ money(acquisitionTotal) }}</p>
            <p class="sim-hero-sub">{{ money(imtPrice) }} + {{ money(imtEstimate?.total) }}</p>
          </div>
        </div>

        <div class="alert alert-danger fs-12 mt-3 mb-0" *ngIf="imtError">
          {{ "t-simulators.t-imt-error" | translate }}
        </div>

        <div class="row g-2 mt-1" *ngIf="imtEstimate">
          <div class="col-6 col-md-4">
            <div class="sim-tile sim-tile-primary">
              <p class="sim-tile-label">{{ "t-simulators.t-imt" | translate }}</p>
              <p class="sim-tile-value">{{ money(imtEstimate.imt) }}</p>
            </div>
          </div>
          <div class="col-6 col-md-4">
            <div class="sim-tile sim-tile-warning">
              <p class="sim-tile-label">{{ "t-simulators.t-stamp-duty" | translate }}</p>
              <p class="sim-tile-value">{{ money(imtEstimate.stampDuty) }}</p>
              <p class="sim-tile-sub text-success" *ngIf="imtEstimate.stampDutyExempt">
                {{ "t-simulators.t-exempt-young" | translate }}
              </p>
              <p class="sim-tile-sub text-success" *ngIf="imtEstimate.stampDutyPartialExempt">
                {{ "t-simulators.t-partial-exempt-young" | translate }}
              </p>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="sim-tile">
              <p class="sim-tile-label">{{ "t-simulators.t-taxable-value" | translate }}</p>
              <p class="sim-tile-value">{{ money(imtEstimate.taxableValue) }}</p>
              <p class="sim-tile-sub text-muted">{{ "t-simulators.t-tables" | translate: { year: imtEstimate.tableYear } }}</p>
            </div>
          </div>
        </div>

        <!-- O passo seguinte da conversa: quanto fica por mês. -->
        <button type="button" class="sim-next" *ngIf="imtEstimate" (click)="goToCreditWithPrice()">
          <span>
            <i class="ri-bank-line me-1"></i>
            {{ "t-simulators.t-go-credit" | translate }}
          </span>
          <i class="ri-arrow-right-line"></i>
        </button>
      </ng-container>
    </div>
  </div>

  <!-- ============================================================= CRÉDITO -->
  <div class="row g-4" *ngIf="tab === 'credit'">
    <div class="col-12 col-lg-5">
      <form [formGroup]="creditForm" class="sim-form">
        <div class="mb-3">
          <label class="form-label d-flex justify-content-between">
            <span>{{ "t-simulators.t-property-price" | translate }}</span>
            <small class="text-primary" *ngIf="linked && imtPrice > 0">
              <i class="ri-link"></i> {{ "t-simulators.t-price-from-imt" | translate }}
            </small>
          </label>
          <div class="input-group input-group-lg sim-input-hero">
            <input
              type="text"
              class="form-control"
              formControlName="propertyPrice"
              mask="separator"
              thousandSeparator=" "
              inputmode="numeric"
              placeholder="250 000"
            />
            <span class="input-group-text">€</span>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label d-flex justify-content-between">
            <span>{{ "t-simulators.t-down-payment" | translate }}</span>
            <small class="text-muted" *ngIf="downPaymentPercent !== null">{{ downPaymentPercent }}%</small>
          </label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              formControlName="downPayment"
              mask="separator"
              thousandSeparator=" "
              inputmode="numeric"
            />
            <span class="input-group-text">€</span>
          </div>
          <div class="sim-presets mt-2">
            <button
              type="button"
              *ngFor="let preset of downPaymentPresets"
              [class.is-active]="isDownPaymentPreset(preset)"
              [disabled]="!(creditPrice > 0)"
              (click)="applyDownPaymentPreset(preset)"
            >
              {{ preset }}%
            </button>
            <small class="text-muted ms-1">{{ "t-simulators.t-down-payment-hint" | translate }}</small>
          </div>
        </div>

        <!-- Crédito jovem: garantia pública, financiamento a 100%. -->
        <label class="sim-check mb-3" [class.is-on]="creditYoungBuyer">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="creditYoungBuyer"
            (change)="onCreditYoungChange($event)"
          />
          <span>
            {{ "t-simulators.t-young-credit" | translate }}
            <small class="d-block text-muted">{{ "t-simulators.t-young-credit-hint" | translate }}</small>
            <small class="d-block text-danger" *ngIf="youngLimitExceeded">
              {{ "t-simulators.t-young-credit-limit" | translate: { limit: money(youngCreditPriceLimit) } }}
            </small>
          </span>
        </label>

        <div class="row g-3 mb-3">
          <div class="col-6">
            <label class="form-label">{{ "t-simulators.t-term" | translate }}</label>
            <div class="input-group">
              <input type="number" class="form-control" formControlName="termYears" min="1" max="50" step="1" />
              <span class="input-group-text">{{ "t-simulators.t-years" | translate }}</span>
            </div>
          </div>
          <div class="col-6">
            <label class="form-label">{{ "t-simulators.t-rate" | translate }}</label>
            <div class="input-group">
              <input type="number" class="form-control" formControlName="ratePercent" min="0" max="20" step="0.05" />
              <span class="input-group-text">%</span>
            </div>
          </div>
        </div>
        <p class="text-muted fs-11 mb-3">{{ "t-simulators.t-rate-hint" | translate }}</p>

        <div>
          <label class="form-label">{{ "t-simulators.t-income" | translate }}</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              formControlName="monthlyIncome"
              mask="separator"
              thousandSeparator=" "
              inputmode="numeric"
            />
            <span class="input-group-text">€/{{ "t-simulators.t-month" | translate }}</span>
          </div>
          <p class="text-muted fs-11 mb-0 mt-1">{{ "t-simulators.t-income-hint" | translate }}</p>
        </div>
      </form>
    </div>

    <div class="col-12 col-lg-7">
      <div class="sim-empty" *ngIf="monthlyPayment === null">
        <i class="ri-bank-line"></i>
        <p>{{ "t-simulators.t-credit-empty" | translate }}</p>
      </div>

      <ng-container *ngIf="monthlyPayment !== null">
        <div class="sim-hero sim-hero-credit">
          <div>
            <p class="sim-hero-label">{{ "t-simulators.t-monthly-payment" | translate }}</p>
            <p class="sim-hero-value">{{ money(monthlyPayment) }}<small>/{{ "t-simulators.t-month" | translate }}</small></p>
            <p class="sim-hero-sub">
              {{ "t-simulators.t-payment-terms" | translate: { years: termYears, rate: ratePercent } }}
              <span *ngIf="creditYoungBuyer"> · {{ "t-simulators.t-young-credit-short" | translate }}</span>
            </p>
          </div>
          <div class="sim-hero-side" *ngIf="effortRate !== null">
            <p class="sim-hero-label">{{ "t-simulators.t-effort-rate" | translate }}</p>
            <p class="sim-hero-side-value sim-effort" [ngClass]="effortClass">{{ effortRate }}%</p>
            <p class="sim-hero-sub">{{ effortLabelKey | translate }}</p>
          </div>
        </div>

        <div class="row g-2 mt-1">
          <div class="col-6 col-md-4">
            <div class="sim-tile sim-tile-primary">
              <p class="sim-tile-label">{{ "t-simulators.t-financed" | translate }}</p>
              <p class="sim-tile-value">{{ money(financed) }}</p>
              <p class="sim-tile-sub text-muted" *ngIf="ltv !== null">LTV {{ ltv }}%</p>
            </div>
          </div>
          <div class="col-6 col-md-4">
            <div class="sim-tile sim-tile-warning">
              <p class="sim-tile-label">{{ "t-simulators.t-total-interest" | translate }}</p>
              <p class="sim-tile-value">{{ money(totalInterest) }}</p>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="sim-tile">
              <p class="sim-tile-label">{{ "t-simulators.t-total-paid" | translate }}</p>
              <p class="sim-tile-value">{{ money(totalPaid) }}</p>
            </div>
          </div>
        </div>

        <!-- Quanto o cliente precisa de ter: entrada mais impostos. -->
        <div class="sim-capital mt-3" *ngIf="ownCapital !== null">
          <div class="sim-capital-head">
            <span><i class="ri-wallet-3-line me-1"></i>{{ "t-simulators.t-own-capital" | translate }}</span>
            <strong>{{ money(ownCapital) }}</strong>
          </div>
          <div class="sim-capital-row">
            <span>{{ "t-simulators.t-down-payment" | translate }}</span>
            <span>{{ money(downPayment) }}</span>
          </div>
          <div class="sim-capital-row" *ngIf="linked">
            <span>
              {{ "t-simulators.t-taxes-total" | translate }}
              <small class="text-muted" *ngIf="!imtEstimate">· {{ "t-simulators.t-taxes-missing" | translate }}</small>
            </span>
            <span>{{ money(linkedTaxes) }}</span>
          </div>
          <p class="text-muted fs-11 mb-0 mt-2" *ngIf="!linked">{{ "t-simulators.t-own-capital-hint" | translate }}</p>
        </div>

        <!-- Amortização ao ano, fechada por omissão. -->
        <button type="button" class="sim-collapse" (click)="showAmortization = !showAmortization">
          <span><i class="ri-table-line me-1"></i>{{ "t-simulators.t-amortization" | translate }}</span>
          <i class="ri-arrow-down-s-line" [class.rotated]="showAmortization"></i>
        </button>
        <div class="sim-table-wrap" *ngIf="showAmortization">
          <table class="table table-sm table-nowrap mb-0 sim-table">
            <thead>
              <tr>
                <th>{{ "t-simulators.t-year" | translate }}</th>
                <th class="text-end">{{ "t-simulators.t-interest" | translate }}</th>
                <th class="text-end">{{ "t-simulators.t-principal" | translate }}</th>
                <th class="text-end">{{ "t-simulators.t-balance" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of amortization">
                <td>{{ row.year }}</td>
                <td class="text-end">{{ money(row.interest) }}</td>
                <td class="text-end">{{ money(row.principal) }}</td>
                <td class="text-end">{{ money(row.balance) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="modal-footer sim-footer">
  <p class="text-muted fs-11 mb-0 me-auto sim-disclaimer">
    <i class="ri-information-line align-bottom me-1"></i>
    {{ (tab === "imt" ? "t-simulators.t-disclaimer-imt" : "t-simulators.t-disclaimer-credit") | translate }}
  </p>
  <button
    type="button"
    class="btn btn-soft-secondary"
    [disabled]="tab === 'imt' ? !imtEstimate : monthlyPayment === null"
    (click)="copySummary()"
  >
    <i class="align-bottom me-1" [ngClass]="copied ? 'ri-check-line' : 'ri-file-copy-line'"></i>
    {{ (copied ? "t-simulators.t-copied" : "t-simulators.t-copy") | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="activeModal.dismiss()">
    {{ "t-close" | translate }}
  </button>
</div>
